var _excluded = ["pastilles"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Label, Header, Grid } from "../..";

/**
  * Pastille.
  */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Pastille = function Pastille(props) {
  var pastilles = props.pastilles,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var pastilleRender = _.map(pastilles, function (pastille) {
    var libelle = pastille.libelle,
      valeur = pastille.valeur,
      couleur = pastille.couleur,
      taille = pastille.taille,
      tailleHeader = pastille.tailleHeader;
    return /*#__PURE__*/_jsxs(Grid.Row, {
      children: [/*#__PURE__*/_jsx(Grid.Column, {
        width: 8,
        verticalAlign: "middle",
        children: /*#__PURE__*/_jsx(Header, {
          as: tailleHeader,
          textAlign: "right",
          children: libelle
        })
      }), /*#__PURE__*/_jsx(Grid.Column, {
        width: 4,
        verticalAlign: "middle",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(Label, {
          color: couleur,
          circular: true,
          size: taille,
          children: valeur
        })
      }), /*#__PURE__*/_jsx(Grid.Column, {
        width: 4
      })]
    });
  });
  return /*#__PURE__*/_jsx(Grid, Object.assign({}, rest, {
    children: pastilleRender
  }));
};

/**
 * Proptypes
 */
Pastille.handledProps = ["pastilles"];
Pastille.propTypes = {
  /** Liste des pastilles */
  pastilles: PropTypes.arrayOf(PropTypes.shape({
    /** Libellé de la pastille */
    libelle: PropTypes.string,
    /** Valeur */
    valeur: PropTypes.number,
    /** Couleur de la pastille */
    couleur: PropTypes.string,
    /** Taille de la pastille */
    taille: PropTypes.string,
    /** taille du titre */
    tailleHeader: PropTypes.string
  }))
};
Pastille.defaultProps = {
  pastilles: []
};
export default Pastille;